import { formatCount, rate } from './format';

// Generated sentences shared by the Impact Report page and its PDF, so both
// always say the same thing and follow the same truthfulness rules.

// Ended cohorts the funnel leaves out because they have no progress data.
export function excludedNote(level) {
  const ended = level.cohorts?.ended ?? 0;
  const covered = level.funnel?.cohorts ?? 0;
  const missing = ended - covered;
  if (!level.cohorts || covered === 0 || missing <= 0) return null;
  return `${missing} ended cohort${
    missing === 1 ? '' : 's'
  } without progress data ${missing === 1 ? 'is' : 'are'} not included above.`;
}

// Sentences under the year table: live years will rise, and drop-off was
// only tracked from a certain year.
export function yearNotes(years) {
  const notes = [];
  const latest = years[years.length - 1];
  if (latest?.cohorts?.live) {
    notes.push(
      `${latest.year} includes ${latest.cohorts.live} live cohort${
        latest.cohorts.live === 1 ? '' : 's'
      }, so its rate will rise.`
    );
  }
  const firstTracked = years.find((year) => (year.drop_off ?? 0) > 0);
  const earlierUntracked =
    firstTracked && years.some((year) => year.year < firstTracked.year);
  if (firstTracked && earlierUntracked) {
    notes.push(
      `Drop-off tracking started in ${firstTracked.year}: ${formatCount(
        firstTracked.drop_off
      )} learners moved to the Drop-off cohort that year. Earlier years show none because moves weren't recorded before then, not because there was no drop-off.`
    );
  }
  return notes;
}

// Plain-language takeaway, shown only when it is true: both groups need
// enough learners for the gap to mean something, and "the gap is in
// recruitment" only when women are clearly under half of enrolment.
const MIN_GROUP_FOR_INSIGHT = 100;

export function genderInsight(buckets) {
  const men = buckets.find((b) => b.value === 'male');
  const women = buckets.find((b) => b.value === 'female');
  if (
    !(men?.enrolled >= MIN_GROUP_FOR_INSIGHT) ||
    !(women?.enrolled >= MIN_GROUP_FOR_INSIGHT)
  ) {
    return null;
  }
  const menRate = rate(men.graduated, men.enrolled);
  const womenRate = rate(women.graduated, women.enrolled);
  if (menRate === null || womenRate === null) return null;
  const gap = Math.abs(menRate - womenRate);
  if (gap < 2) {
    return women.percent < 45
      ? 'Women graduate at about the same rate as men; the gap is in recruitment.'
      : 'Women and men graduate at about the same rate.';
  }
  return womenRate > menRate
    ? `Women graduate ${gap.toFixed(1)} points ahead of men.`
    : `Women graduate ${gap.toFixed(1)} points behind men.`;
}
